<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

        <div class="np-base-dialog modal-dialog modal-lg modal-dialog-centered w-100" :class="modalClass">
                <div class="modal-content shadow">
                    <div class="modal-header border-0 p-4 pb-2">
                        <span class="col-sm-8 d-flex align-middle">
                            <svg class="icon"><use href="@/assets/images/icons/cog.svg#icon"></use></svg>
                            {{ !this.isNewDepartment ? $t("UI.organization.department") : $t("UI.organization.addDepartment") }}
                        </span>
                        <div class="d-flex justify-content-end flex-grow-1">
                            <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                            </button>
                        </div>
                    </div>

                    <div class="modal-body ps-3 pe-3">
                        <div class="row m-0 w-100 h-100">
                            <div class="col me-lg-2 pe-lg-4 np-border-right">
                                <div class="mb-4">
                                    <label class="np-font-m np-f-medium mb-1">{{ $t("UI.organization.department") }}</label>
                                    <input type="text" class="form-control np-input" id="projectName" aria-describedby="departmentHelp" v-model="departmentData.title">
                                    <small id="departmentHelp" class="form-text text-muted"></small>
                                </div>       
                                <div class="mb-4">
                                    <label class="np-font-m np-f-medium mb-1">{{ $t("UI.organization.director") }}</label>
                                    <vSelect 
                                        class="align-items-center flex-grow-1 np-mr-2" 
                                        placeholder="" 
                                        v-model="department_head"
                                        label="name"
                                        :clearable="false"
                                        :reduce="employee => employee.id"
                                        :options="depEmployees" 
                                    />
                                    <small id="departmentHelp" class="form-text text-muted"></small>
                                </div>                                                                                                                                                                                                            
                            </div>
                            <div class="col">
                                <div class="mb-4">
                                    <label class="np-font-m np-f-medium mb-1">{{ $t("UI.organization.higherDepartment") }}</label>
                                    <vSelect 
                                        class="align-items-center flex-grow-1 np-mr-2" 
                                        placeholder="" 
                                        v-model="departmentData.parent_id"
                                        label="title"
                                        :clearable="false"
                                        :reduce="higherDepartments => higherDepartments.id"
                                        :options="higherDepartments"                                         
                                    />
                                    <small id="departmentHelp" class="form-text text-muted"></small>
                                </div>       
                                <div class="mb-4">
                                    <label class="np-font-m np-f-medium mb-1">{{ $t("UI.organization.director") }}</label>
                                    <div class="np-group">
                                        <span>{{ higherDepartmentHead }}</span>
                                    </div>
                                    <small id="departmentHelp" class="form-text text-muted"></small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer p-3">
                        <button type="button" class="np-btn np-danger px-4 me-1"
                            data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                        <button type="button" class="np-btn np-success-filled px-4" @click="save()">{{ $t("UI.save") }}</button>
                    </div>                    
                </div>
        </div>
    </div>
</template>

<script>
import { useOrganizationStore } from '@/stores/organizationStore'
import { Modal } from "bootstrap"
import { ref } from 'vue'

export default {
    components: {
    },
    props: {
        modalID: {
            type: String,
            required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        }       
    }, 
    data() {
        return {  
            departmentData: {},
            department_head: null,
            theModal: null,
            theModalLabel: null
        }
    },    
    computed: {
        isNewDepartment() {
            return !!!this.departmentData.id
        },
        organizationStore() {
            return useOrganizationStore()
        },
        higherDepartments() {
            const deps = this.organizationStore.departments
            return deps
        },        
        higherDepartmentHead() {
            const depHead = this.higherDepartments.find(dep => dep.id === this.departmentData.parent_id)?.dep_head
            return depHead ? depHead.user_data.first_name + ' ' + depHead.user_data.last_name : this.$t("UI.organization.notAssigned")
        },
        depHead: {
            get() {

            },
            set() {

            }
        },
        depEmployees() {
            let depEmp = []
            if (this.isNewDepartment) {
                this.organizationStore?.employee?.forEach(emp => {
                    depEmp.push({
                        id: emp.id,
                        name: emp.user_data.first_name + " " + emp.user_data.last_name
                    })
                })
            } else {
                this.departmentData?.employee?.forEach(emp => {
                    depEmp.push({
                        id: emp.id,
                        name: emp.user_data.first_name + " " + emp.user_data.last_name
                    })
                })
            }
            return depEmp
        },      
        employees() {
            return this.organizationStore.employees
        }       
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})
    },           
    methods: {
        shows(depInfo) {
            this.departmentData = Object.assign({}, depInfo)
            if (!this.isNewDepartment) {
                this.department_head = this.departmentData.dep_head?.id
            } else {
                this.department_head = null
            }
            this.theModal.show()
        },
        hide() {
            this.theModal.hide()
        },
        async close() {
            this.$emit('closeModal')
        },
        async save() {
            this.departmentData.status_id = 1 // NEED TO BE CHANGED!!!
            this.departmentData.organization_id = this.organizationStore.organizationInfo.id
            this.departmentData.department_head = this.department_head

            const response = await this.organizationStore.updateDepartment(this.departmentData)

            if (response.id) {
                this.departmentData = { ... response }
            }

            await this.$emit('save', this.departmentData)
            this.hide()
        }, 
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>